import { render, staticRenderFns } from "./ProductItemShow.vue?vue&type=template&id=7a9b6b1c&"
import script from "./ProductItemShow.vue?vue&type=script&lang=js&"
export * from "./ProductItemShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports